export class CONTENT {

    /**
     * Trang Tiếng anh
     */
    /**
     * Index
     */
    static readonly CONTENT_ROYAL_HEADER_VN = 'CONTENT_ROYAL_HEADER_V2_EN';
    static readonly CONTENT_ROYAL_HEADER_MENU_VN = 'CONTENT_ROYAL_HEADER_MENU_EN';
    static readonly CONTENT_ROYAL_FOOTER_VN = 'CONTENT_ROYAL_FOOTER_V2_EN';
    static readonly CONTENT_ROYAL_HOME_CHUONGTRINHHOC_VN = 'CONTENT_ROYAL_HOME_CHUONGTRINHHOC_V2_EN';
    static readonly CONTENT_ROYAL_HOME_NOIVECHUNGTOI_VN = 'CONTENT_ROYAL_HOME_NOIVECHUNGTOI_V2_EN';
    static readonly CONTENT_ROYAL_HOME_MAP_VN = 'CONTENT_ROYAL_HOME_MAP_EN';


    /**
     * Tổng quan
     */
    static readonly CONTENT_ROYAL_TONGQUAN_VN = 'CONTENT_ROYAL_TONGQUAN_V2_EN';


    /**
     * Chương trình học
     */
    static readonly CONTENT_ROYAL_CHUONGTRINHHOC_VN = 'CONTENT_ROYAL_CHUONGTRINHHOC_V2_EN';
    static readonly CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_VN = 'CONTENT_ROYAL_CHUONGTRINHHOC_MAMNON_V2_EN';
    static readonly CONTENT_ROYAL_CHUONGTRINHHOC_TIEUHOC_VN = 'CONTENT_ROYAL_CHUONGTRINHHOC_TIEUHOC_V2_EN';
    static readonly CONTENT_ROYAL_CHUONGTRINHHOC_TRUNGHOC_VN = 'CONTENT_ROYAL_CHUONGTRINHHOC_TRUNGHOC_V2_EN';


    /**
     * Môi trường học tập
     */
    static readonly CONTENT_ROYAL_MOITRUONGHOCTAP_VN = 'CONTENT_ROYAL_MOITRUONGHOCTAP_V2_EN';
    static readonly CONTENT_ROYAL_COSO_VN = 'CONTENT_ROYAL_COSO_V2_EN';


    /**
     * Tuyển sinh
     */
    static readonly CONTENT_ROYAL_TUYENSINH_VN = 'CONTENT_ROYAL_TUYENSINH_V2_EN';
    static readonly CONTENT_ROYAL_TUYENSINH_BIEUPHI_VN = 'CONTENT_ROYAL_TUYENSINH_BIEUPHI_V2_EN';

    /**
     * Hình ảnh
     */
    static readonly CONTENT_ROYAL_HINHANH_BANNER_VN = 'CONTENT_ROYAL_HINHANH_BANNER_EN';
    static readonly CONTENT_ROYAL_HINHANH_GALLERY_VN = 'CONTENT_ROYAL_HINHANH_GALLERY_EN';
    static readonly CONTENT_ROYAL_HINH_ANH_MAM_NON_VN = 'CONTENT_ROYAL_HINH_ANH_MAM_NON_EN'
    static readonly CONTENT_ROYAL_HINH_ANH_PHO_THONG_VN = 'CONTENT_ROYAL_HINH_ANH_PHO_THONG_EN'
    static readonly CONTENT_ROYAL_VIDEO_VN = 'CONTENT_ROYAL_VIDEO_EN'

    /**
     * Studio
     */
    static readonly CONTENT_ROYAL_FRAME_STUDIO = 'CONTENT_ROYAL_FRAME_STUDIO_V2_EN';

    /**
     * 404
     */
     static readonly CONTENT_ROYAL_NOT_FOUND_EN = 'CONTENT_ROYAL_NOT_FOUND_EN';

}